import styled from 'styled-components';

export const UserLoaderStyled = styled.div<{ isLoading: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: ${({ theme }) => theme.colorBackgroundPrimary};
  transition: ${({ theme }) => theme.transitions.medium};
  opacity: ${({ isLoading }) => isLoading ? 1 : 0};
  z-index: ${({ isLoading }) => isLoading ? 99 : 1};

  svg {
    width: 172px;
    height: 42px;
    animation: 1s linear 0s infinite alternate scaleLogo;

    path {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6) {
        fill: ${({ theme }) => theme.colorLogo};
      }
    }

    @keyframes scaleLogo {
      from {
        transform: scale(1, 1);
      }
      to {
        transform: scale(1.2, 1.2)
      }
    }
  }
`;
